import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { CATEGORIES } from "@/lib/api";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 mt-20 bg-[#0A0A0D]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <Logo size="lg" />
          <p className="text-sm text-slate-400 mt-4 leading-relaxed max-w-xs">
            सिर्फ़ सुर्खियाँ नहीं — हर खबर की पूरी कहानी। विस्तृत, निष्पक्ष और गहराई वाली पत्रकारिता।
          </p>
        </div>
        <div>
          <h4 className="font-mono-meta text-xs text-[#FFD400] uppercase tracking-[0.25em] mb-4">श्रेणियाँ</h4>
          <div className="grid grid-cols-2 gap-2">
            {CATEGORIES.map((c) => (
              <Link
                key={c.id}
                to={c.id === "top-stories" ? "/" : `/category/${c.id}`}
                className="text-sm text-slate-400 hover:text-[#FFD400] transition-colors"
              >
                {c.hi}
              </Link>
            ))}
          </div>
        </div>
        <div>
          <h4 className="font-mono-meta text-xs text-[#FFD400] uppercase tracking-[0.25em] mb-4">संपर्क</h4>
          <p className="text-sm text-slate-400">contact@khabrik.news</p>
        </div>
      </div>
      <div className="border-t border-white/[0.06] py-5 text-center font-mono-meta text-[11px] text-slate-600 uppercase tracking-widest">
        © 2026 Khabrik News — खबरिक न्यूज़
      </div>
    </footer>
  );
}
